import Header from "../components/home/Header";
import Aboutus from "../components/home/Aboutus";
import ChooseUs from "../components/home/ChooseUs";
import AppSection from "../components/home/AppSection";
import VideoSection from "../components/home/videoSection";
import Form from "../components/home/Form";
import Footer from "../components/Footer";
import WhyChooseUs from "../components/home/WhyChooseUs";
import LatestProducts from "../components/home/LatestProducts";

const Index = (props) => {
  return (
    <>
      <Header data={props.data.header} />
      <Aboutus data={props.data.aboutUs} />
      {/* <ChooseUs data={props.data.chooseUs} /> */}
      <WhyChooseUs data={props.data.chooseUs} />
      <LatestProducts />
      <AppSection data={props.data.appSection} />
      <Form data={props.data.form} />
      <Footer data={props.data.footer} />
    </>
  );
};

export default Index;
